import Menu from "pages/menuMain/menu";
import React, { useEffect, useRef, useState } from "react";
import { Helmet } from "react-helmet";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import LoaderPage from "components/loader/LoaderPage";
import RewardItem from "./RewardItem";
import Banners from "../centerComponent/Banners";
import { RewardList } from "services/Api/Module/Reward";
import CollectpointHeader from "../centerComponent/collectPointHeader";
import Submenu from "pages/centerComponent/Submenu";

const DEF_LIMIT = 5;

const Reward = () => {
  const [rewards, setRewards] = useState([]);
  const [rowCount, setRowCount] = useState(0);
  const [isLoad, setIsLoad] = useState(true);
  const [isLoadingMore, setIsLoadingMore] = useState(false);
  const navigate = useNavigate();

  const stateProfile = useSelector((state) => state.profile.dataUser);
  const sentinelRef = useRef(null);
  const loadingRef = useRef(false);

  const hasMore = rewards.length < rowCount;

  const fetchRewardPage = async (nextOffset, append) => {
    if (loadingRef.current) return;
    loadingRef.current = true;
    if (append) {
      setIsLoadingMore(true);
    }

    try {
      const { data } = await RewardList({
        params: { limit: DEF_LIMIT, offset: nextOffset },
      });

      if (data?.resultCode === "20000") {
        const items = Array.isArray(data.resultData) ? data.resultData : [];
        setRowCount(Number(data.rowCount) || 0);
        setRewards((prev) => (append ? [...prev, ...items] : items));
      }
    } catch (e) {
      console.log(e);
    } finally {
      setIsLoad(false);
      setIsLoadingMore(false);
      loadingRef.current = false;
    }
  };

  useEffect(() => {
    setRewards([]);
    setRowCount(0);
    setIsLoad(true);
    fetchRewardPage(0, false);
  }, [stateProfile?.id]);

  useEffect(() => {
    if (!hasMore || isLoad) return;
    const el = sentinelRef.current;
    if (!el) return;

    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0]?.isIntersecting) {
          fetchRewardPage(rewards.length, true);
        }
      },
      { root: null, rootMargin: "280px 0px", threshold: 0 }
    );

    observer.observe(el);
    return () => observer.disconnect();
  }, [hasMore, isLoad, rewards.length]);

  return (
    <div>
      <Helmet>
        <title>โคอะลา มาร์ช</title>
        <meta name="title" content="โคอะลา มาร์ช" />
        <meta name="description" content="" />
        <meta name="keyword" content="" />
        <meta property="og:title" content="โคอะลา มาร์ช" />
        <meta property="og:description" content="" />
        <meta property="og:image" content="" />
        <meta property="og:url" content="" />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="" />
      </Helmet>

      <div id="pageReward-All">
        <main>
          <div className="wrapContent">
            <CollectpointHeader />
            {!isLoad ? (
              rewards.length ? (
                <section id="pContent">
                  <Submenu />
                  <Banners currentPage="Rewards" />
                  <div className="bTitle">
                    <h2>Rewards</h2>
                    <p>ใช้ Point แลกของที่คุณชอบ</p>
                  </div>
                  <div className="bBtn">
                    <a className="btn ">รางวัลทั้งหมด</a>
                    <a
                      className="btn outline"
                      onClick={() => navigate("/history-reward")}
                    >
                      ประวัติการแลก
                    </a>
                  </div>
                  <div className="bGroupItem">
                    {rewards.map((item) => (
                      <RewardItem key={item.id} item={item} />
                    ))}
                  </div>
                  {hasMore ? (
                    <div
                      ref={sentinelRef}
                      style={{ height: 1 }}
                      aria-hidden="true"
                    />
                  ) : null}
                  {isLoadingMore ? (
                    <div style={{ padding: "16px 0 80px" }}>
                      <LoaderPage />
                    </div>
                  ) : null}
                </section>
              ) : (
                <section id="pComingSoon">
                  <p>รอติดตาม Reward เร็ว ๆ นี้</p>
                </section>
              )
            ) : (
              <div style={{ marginTop: "-20vh" }}>
                <LoaderPage />
              </div>
            )}
            <Menu />
          </div>
        </main>
      </div>
    </div>
  );
};

export default Reward;
